// Una sola famiglia di icone: Lucide, tratto 1,75, griglia 24 (pacchetto del 29-10, lib/icons.ts).
// I nomi sono quelli della tavola «Icone». Misure: 16 nelle etichette (tratto 2), 18 nei pulsanti,
// 20 menu e righe, 22 testata e barra del telefono, 28 negli stati vuoti e di errore.
// Tutte esistono in lucide-react 0.516: nessuna sostituita.
import {
  ArrowLeftRight, ArrowRight, BookOpen, BookCopy, Calendar, CalendarCheck, Camera, ChartColumn, Check, ChevronDown,
  ChevronLeft, ChevronRight, Clock, Columns3, Download, Ellipsis, Euro, Eye, FileCheck, FileText, Funnel,
  Image, LayoutGrid, Link, List, Lock, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Paperclip,
  Phone, Plus, Receipt, RefreshCw, Search, Send, ShieldCheck, SlidersHorizontal, Store, Sun, Table,
  TriangleAlert, Unlink, Upload, User, UserPlus, Users, WifiOff, Wrench, X,
} from "lucide-react";

export const ICON_STROKE = 1.75;

/** Navigazione */
export const navIcons = {
  dashboard: LayoutGrid,
  oggi: CalendarCheck,
  clienti: Users,
  calendario: Calendar,
  preventivi: FileText,
  listini: BookCopy,
  assistenza: Wrench,
  messaggi: MessageSquare,
  contratti: FileCheck,
  fatture: Receipt,
  messaggistica: Send,
  impostazioni: SlidersHorizontal,
  guide: BookOpen,
  menu: Menu,
  sede: Store,
};

/** Azioni */
export const actionIcons = {
  nuovo: Plus,
  cerca: Search,
  chiudi: X,
  fatto: Check,
  apri: ChevronDown,
  indietro: ChevronLeft,
  vai: ChevronRight,
  daA: ArrowRight,
  altro: Ellipsis,
  filtra: Funnel,
  riprova: RefreshCw,
  carica: Upload,
  scarica: Download,
  allega: Paperclip,
  foto: Camera,
  sposta: ArrowLeftRight,
  esci: LogOut,
  mostra: Eye,
};

/** Cose e stati */
export const thingIcons = {
  persona: User,
  invita: UserPlus,
  telefono: Phone,
  whatsapp: MessageCircle,
  email: Mail,
  indirizzo: MapPin,
  orario: Clock,
  importo: Euro,
  immagine: Image,
  grafico: ChartColumn,
  tabella: Table,
  elenco: List,
  colonne: Columns3,
  codiceVerifica: ShieldCheck,
  bloccato: Lock,
  link: Link,
  scollegato: Unlink,
  attenzione: TriangleAlert,
  senzaRete: WifiOff,
  temaChiaro: Sun,
};
